import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
import apiKey from './api-key'
import versions from './versions'
import conversations from './conversations'
/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/checkup'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/dashboard/checkup',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/checkup'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/checkup'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/checkup'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/checkup'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/checkup'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/checkup'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\CheckupController::enabled
* @see app/Http/Controllers/Admin/CheckupController.php:109
* @route '/dashboard/checkup/enabled'
*/
export const enabled = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: enabled.url(options),
    method: 'patch',
})

enabled.definition = {
    methods: ["patch"],
    url: '/dashboard/checkup/enabled',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\CheckupController::enabled
* @see app/Http/Controllers/Admin/CheckupController.php:109
* @route '/dashboard/checkup/enabled'
*/
enabled.url = (options?: RouteQueryOptions) => {
    return enabled.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\CheckupController::enabled
* @see app/Http/Controllers/Admin/CheckupController.php:109
* @route '/dashboard/checkup/enabled'
*/
enabled.patch = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: enabled.url(options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\CheckupController::enabled
* @see app/Http/Controllers/Admin/CheckupController.php:109
* @route '/dashboard/checkup/enabled'
*/
const enabledForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: enabled.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\CheckupController::enabled
* @see app/Http/Controllers/Admin/CheckupController.php:109
* @route '/dashboard/checkup/enabled'
*/
enabledForm.patch = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: enabled.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

enabled.form = enabledForm

/**
* @see \App\Http\Controllers\Admin\CheckupController::settings
* @see app/Http/Controllers/Admin/CheckupController.php:145
* @route '/dashboard/checkup/settings'
*/
export const settings = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: settings.url(options),
    method: 'put',
})

settings.definition = {
    methods: ["put"],
    url: '/dashboard/checkup/settings',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\CheckupController::settings
* @see app/Http/Controllers/Admin/CheckupController.php:145
* @route '/dashboard/checkup/settings'
*/
settings.url = (options?: RouteQueryOptions) => {
    return settings.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\CheckupController::settings
* @see app/Http/Controllers/Admin/CheckupController.php:145
* @route '/dashboard/checkup/settings'
*/
settings.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: settings.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\CheckupController::settings
* @see app/Http/Controllers/Admin/CheckupController.php:145
* @route '/dashboard/checkup/settings'
*/
const settingsForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: settings.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\CheckupController::settings
* @see app/Http/Controllers/Admin/CheckupController.php:145
* @route '/dashboard/checkup/settings'
*/
settingsForm.put = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: settings.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

settings.form = settingsForm

/**
* @see \App\Http\Controllers\Admin\CheckupController::texts
* @see app/Http/Controllers/Admin/CheckupController.php:174
* @route '/dashboard/checkup/texts'
*/
export const texts = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: texts.url(options),
    method: 'put',
})

texts.definition = {
    methods: ["put"],
    url: '/dashboard/checkup/texts',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\CheckupController::texts
* @see app/Http/Controllers/Admin/CheckupController.php:174
* @route '/dashboard/checkup/texts'
*/
texts.url = (options?: RouteQueryOptions) => {
    return texts.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\CheckupController::texts
* @see app/Http/Controllers/Admin/CheckupController.php:174
* @route '/dashboard/checkup/texts'
*/
texts.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: texts.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\CheckupController::texts
* @see app/Http/Controllers/Admin/CheckupController.php:174
* @route '/dashboard/checkup/texts'
*/
const textsForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: texts.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\CheckupController::texts
* @see app/Http/Controllers/Admin/CheckupController.php:174
* @route '/dashboard/checkup/texts'
*/
textsForm.put = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: texts.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

texts.form = textsForm

/**
* @see \App\Http\Controllers\Admin\CheckupController::sandbox
* @see app/Http/Controllers/Admin/CheckupController.php:218
* @route '/dashboard/checkup/sandbox'
*/
export const sandbox = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sandbox.url(options),
    method: 'post',
})

sandbox.definition = {
    methods: ["post"],
    url: '/dashboard/checkup/sandbox',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\CheckupController::sandbox
* @see app/Http/Controllers/Admin/CheckupController.php:218
* @route '/dashboard/checkup/sandbox'
*/
sandbox.url = (options?: RouteQueryOptions) => {
    return sandbox.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\CheckupController::sandbox
* @see app/Http/Controllers/Admin/CheckupController.php:218
* @route '/dashboard/checkup/sandbox'
*/
sandbox.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sandbox.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\CheckupController::sandbox
* @see app/Http/Controllers/Admin/CheckupController.php:218
* @route '/dashboard/checkup/sandbox'
*/
const sandboxForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: sandbox.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\CheckupController::sandbox
* @see app/Http/Controllers/Admin/CheckupController.php:218
* @route '/dashboard/checkup/sandbox'
*/
sandboxForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: sandbox.url(options),
    method: 'post',
})

sandbox.form = sandboxForm

const checkup = {
    index: Object.assign(index, index),
    enabled: Object.assign(enabled, enabled),
    settings: Object.assign(settings, settings),
    apiKey: Object.assign(apiKey, apiKey),
    texts: Object.assign(texts, texts),
    versions: Object.assign(versions, versions),
    conversations: Object.assign(conversations, conversations),
    sandbox: Object.assign(sandbox, sandbox),
}

export default checkup